import useApiQuery from 'shared/hooks/use-api-query';

interface Props {
  companyId?: string;
  latitude?: number;
  longitude?: number;
  neighborhoodId?: string;
}

const useDeliveryPrice = ({
  companyId,
  latitude,
  longitude,
  neighborhoodId,
}: Props) => {
  return useApiQuery({
    url: `/orders/companies/${companyId}/delivery-price?latitude=${latitude}&longitude=${longitude}&neighborhoodId=${neighborhoodId}`,
    enabled: !!companyId && !!latitude && !!longitude && !!neighborhoodId,
  });
};

export default useDeliveryPrice;
